import { useCallback, useEffect, useState } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"

const CATALOG_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/warnings/catalog`

// Catalogo de motivos: etiqueta, si corta o solo informa, y si se puede relanzar.
// Lo sirve webback desde rentacar-db, que es la misma fuente que usa search-export
// para emitirlos; asi el front no duplica los codigos.
export default function useAutoEuropeWarningsCatalog() {
	const [catalog, setCatalog] = useState({})

	useEffect(() => {
		getSubmit(CATALOG_API)
			.then(data => setCatalog(Object.fromEntries((data ?? []).map(x => [x.reason, x]))))
			// Sin catalogo el aviso sigue viendose, solo que con el codigo crudo:
			// preferible a esconder la seccion entera.
			.catch(() => setCatalog({}))
	}, [])

	const getLabel = useCallback(reason => catalog[reason]?.label ?? reason, [catalog])
	const getMessage = useCallback(reason => catalog[reason]?.message ?? '', [catalog])
	const isRelaunchable = useCallback(reason => !!catalog[reason]?.relaunchable, [catalog])
	const isInfo = useCallback(reason => catalog[reason] ? !catalog[reason].blocking : false, [catalog])

	return { getLabel, getMessage, isRelaunchable, isInfo }
}
